import { render } from "./CoaView.vue?vue&type=template&id=d0f1de66"
import script from "./CoaView.vue?vue&type=script&lang=js"
export * from "./CoaView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__